const videoTrackingEvents = {
    "MEDIA_START": {
        'eVar170': 'true', 
        'events': 'event4,event2,event27,event227',
    },
    "PLAYBACK_PERCENT_25": {
        'eVar170': 'true'
    },
    "PLAYBACK_PERCENT_50": {
        'eVar170': 'true'
    },
    "PLAYBACK_PERCENT_75": {
        'eVar170': 'true'
    }, 
    "MEDIA_COMPLETE" : {
        'eVar170': 'true', 
        'events': 'event2,event28,event228',
    }
};

const setAutoPlayTrackingObj = (trackingObj, autoPlayTracking) => {
    const pEventKey = trackingObj?.wire?.pEventKey;
    const config = videoTrackingEvents?.[pEventKey];

    if (!autoPlayTracking || !trackingObj || !config) {
        return trackingObj;
    };
 
    const cloned = {...trackingObj};
    for (const [key, value] of Object.entries(config)) {
         if (trackingObj?.[key]) {
             cloned[key] = value;
         }     
    }

    return cloned;
};

export default setAutoPlayTrackingObj;
